module.exports = __webpack_public_path__ + "img/Kings.a9318bdd.png";